import React from 'react';
import type { FC } from 'react';
import { Flex, Image } from '@chakra-ui/react';
import { getAssetUrl } from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils';
import { ErrorBoundary } from 'react-error-boundary';
import { FormattedMessage } from 'react-intl';
import { Header, Text } from '../../../ui-components';
import { EnhancedErrorCategories } from '../EnhancedErrorCategories';

export const SimpleError: FC<{
    error: { message?: string; stack?: string };
}> = () => (
    <>
        <Flex
            data-testid="oops-error-container"
            background="white"
            direction="column"
            alignItems="center"
            paddingX={{ base: 0, md: 8, lg: 10, xl: 16 }}
            paddingBottom={8}
        >
            <Flex
                gap={8}
                width="100%"
                maxWidth={1792}
                direction={{ base: 'column', sm: 'row' }}
                mb={8}
            >
                <Flex
                    flex={{ base: 0, sm: 1 }}
                    direction="column"
                    justifyContent="center"
                    gap="2rem"
                    padding={{ base: '2rem 1rem', md: '2rem', xl: '2.5rem' }}
                >
                    <Flex direction="column">
                        <Header
                            id="oops-error-title"
                            margin="0px 0px 4px"
                            as="h3"
                            variant="header3"
                            style="bold"
                        >
                            <FormattedMessage
                                id="error.generic.title"
                                defaultMessage="OOPS. Well, that page didn’t turn out."
                            />
                        </Header>
                        <Text id="oops-error-subtitle" type="body">
                            <FormattedMessage
                                id="error.generic.main-message"
                                defaultMessage="Don't worry, even the best chefs get lost sometimes."
                            />
                        </Text>
                    </Flex>

                    <FormattedMessage
                        id="error.generic.call-to-action"
                        defaultMessage="We'll check our recipe. Meanwhile, try entering what you are looking for in the search bar below."
                    />
                </Flex>
                <Flex
                    flex={{ base: 0, sm: 1 }}
                    direction={{ base: 'column', md: 'row' }}
                    justifyContent={{ base: 'start', md: 'end' }}
                    height={{ base: '448px', xl: '582.4px' }}
                >
                    <Image
                        data-testid="oops-error-image"
                        src={getAssetUrl('static/img/pdp/error-image.png')}
                        alt="Error image"
                    />
                </Flex>
            </Flex>
        </Flex>

        <ErrorBoundary fallback={null}>
            <Flex direction="row" paddingX={{ base: 0, md: 8, lg: 10, xl: 16 }} paddingBottom={8}>
                <EnhancedErrorCategories />
            </Flex>
        </ErrorBoundary>
    </>
);
